import { Paper, Typography } from '@mui/material';
import React from 'react';

interface BenefitHintProps {
  title?: string | React.ReactNode;
  description: React.ReactNode;
}

const BenefitHint: React.FC<BenefitHintProps> = ({ title, description }) => (
  <Paper sx={{ py: 2, px: 4, width: '100%' }}>
    <Typography variant="h3" gutterBottom>
      {title}
    </Typography>
    {description}
  </Paper>
);

export default BenefitHint;
